import chengButton from './chengButton'
import chengHeader from './chengHeader'

const components = [
    chengButton,
    chengHeader
]

const install = function (Vue) {
    if(install.installed) return
    components.map(component => Vue.component(component.name,component))
}

if (typeof window !== 'undefined' && window.Vue){
    install(window.Vue)
}

export default {
    install,
    chengButton,
    chengHeader
}